"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sounds = void 0;
class Sounds {
    gameEvents;
    explosion;
    torpedo;
    constructor(gameEvents) {
        this.gameEvents = gameEvents;
        gameEvents.on('torpedo-launched', (isPlayer) => this.onTorpedoLaunched(isPlayer));
        gameEvents.on('player-exploded', () => this.onPlayerExploded());
    }
    preload(scene) {
        scene.load.audio('explosion', 'assets/sounds/explosion.mp3');
        scene.load.audio('torpedo', 'assets/sounds/torpedo.mp3');
    }
    create(scene) {
        this.explosion = scene.sound.add('explosion');
        this.torpedo = scene.sound.add('torpedo');
    }
    onTorpedoLaunched(isPlayer) {
        if (isPlayer) {
            this.torpedo?.play();
        }
    }
    onPlayerExploded() {
        this.explosion?.play();
    }
}
exports.Sounds = Sounds;
